import React, { Component } from 'react';
import { CookieWrap as Cookies } from "../helper/cookie-wrap";

import './styles.scss';

import WLFList from '../components/WLFList';
import CSSEditor from '../components/CSSEditor/CSSEditor';
import BannerMenu from "../components/BannerMenu";
import AllSAUsers from "../components/SA_UserPortfolios";
import AllWlf from "../components/SA_Wlf";
import WlfComponent from "../components/Wlf";
import OnboardingSummary from "../components/OnboardingSummary";
import UserComponent from "../components/User";
import PortfolioDashboard from "../components/PortfolioDashboard";
import { Clone, Delete } from "./actions";
import {urlParamToObj} from "../../lib/url-util";
import {getRGB} from "../../lib/color";
import { is_uuid } from "../../lib/uuid";
import { objToUrlParam } from "../../lib/url-util";
import {DynamoDashboard} from "../components/SA_UserState/dynamo/dynamo-dashboard";
import { deep_copy } from "../../lib/js-utils";
import SAWLFAdmins from "../components/SA_WlfAdmins";
import SAPayments from "../components/SAPayments";
import SASymbols from "../components/SASymbols";
import SAIRR from "../components/SAIRR";
import SAAllocator from "../components/SAAllocator";
import SANotification from "../components/SANotification";
import { NotificationType } from "../../lib/proto/notification";
import {DashboardContainer} from "../funcs/utils";
import OnboardingUser from "../onboarding";
import {get_now_sec} from "../../lib/time";
import SASecurityPurchase from "../components/SASecurityPurchase";
import E2ETests from "../components/E2ETests";
import WhiteLabelFirmsTable from '../components/WhiteLabelFirmsTable/WhiteLabelFirmsTable';

const bannerButtons = [
  {
    label: "CSS Editor",
    id: "css-editor",
  },
  {
    label: "Users",
    id: "user",
  },
  {
    label: "White Labeled Firms",
    id: "wlf",
  },
  {
    label: "Payments",
    id: "payments",
  },
  {
    label: "WLF Admins",
    id: "wlf-admins",
  },
  {
    label: "Production",
    id: "prod",
    value: "symbols",
    options: [
      {
        id: "symbols",
        label: "Symbols",
      },
      {
        id: "irr_scores",
        label: "IRR Scores",
      },
      {
        id: "rebalance",
        label: "Rebalance",
      },
      {
        id: "allocator",
        label: "Allocator",
      },
      {
        id: "security_purchase",
        label: "Purchases",
      },
      {
        id: "tests",
        label: "e2e Testing",
      }
    ]
  },
];

const VIEW_TYPE = {
  username: "username",
  onboarding: "onboarding",
}

const IS_ONBOARDING_SEGMENT = segment => {
  const re = /^onboarding_(\d{4})$/;
  return segment.match(re);
}

class Superadmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedWlf: props.wlf ? props.wlf[0].id : false,
      listView: true,
      isSaving: false,
      message: false,
    };
  }

  componentDidMount(){
    this.props.getAllCSS();
    this.maybeExpireTimestamp();
  }

  maybeExpireTimestamp = () => {
    // ListUsers paging timestamp expires in 60 minutes
    const args = this.getArgs();
    if ("page_token" in args && 'timestamp' in args) {
      const timestamp = parseInt(args.timestamp, 10);
      const now = get_now_sec();
      if (timestamp + 55 * 60 < now) {
        // Expire in 55 minutes
        console.log("expire paging token");
        const path = this.props.location.pathname;
        delete args.timestamp;
        delete args.page_token;
        this.props.navigatePath(path, args);
      }
    }
  }

  changeSelection = e => {
    this.setState({selectedWlf: e.target.value});
  }

  gotoLandingPage = e => {
    const {selectedWlf} = this.state;
    const cookies = new Cookies();
    cookies.set('wlf', selectedWlf, { path: '/' });
    window.location = '/login/';
    e.preventDefault();
  }

  editCSS = selectedWlf => {
    this.props.editCSS(true, selectedWlf);
  }

  cloneWLF = wlf_id => {
    Clone(wlf_id, this.props.token)
      .then(() => {
        this.props.getAllCSS();
      })
  };

  deleteWLF = wlf_id => {
    Delete(wlf_id, this.props.token)
      .then(() => {
        this.props.getAllCSS();
      });
  };

  onCancel = () => {
    this.props.editCSS(false);
  }

  clearMessage = () => {
    this.setState({message: false});
  };

  renderAllWlf = () => {
    return (
      <AllWlf />
    )
  };

  renderCSSEditor = () => {
    const selectedWlf = this.getNextSegment(0);
    const isEditingCSS = !!selectedWlf;
    const allCSS = this.props.allCSS;
    const wlf_to_edit = isEditingCSS ? deep_copy(allCSS[selectedWlf]) : null;
    const {message} = this.state;

    return (
      <div>
        {!isEditingCSS &&
        <nav className="level container switch-container" >
          <div className="level-left">
            {message &&
            <div className="level-item">
              <div className="message-area">
                <span>{message}</span>
                <button className="delete" onClick={this.clearMessage}></button>
              </div>
            </div>
            }
          </div>
        </nav>}

        {!isEditingCSS &&
        <section className="container super-admin-container">
          <WLFList collection={allCSS}
                   onEdit={this.editCSS}
                   onClone={this.cloneWLF}
                   onDelete={this.deleteWLF}/>
        </section>}


        {isEditingCSS &&
        <section className="container super-admin-container">
          <CSSEditor wlf={wlf_to_edit} onCancel={this.onCancel} />
        </section>}

      </div>
    )
  };

  renderNothing = () => {
    return null;
  };

  getCurrentSegment = () => {
    return this.getCurrentPath().split('/')[2];
  };

  /**
   * Return the {@param index}th segment after the current segment.
   */
  getNextSegment = (index) => {
    const path = this.getCurrentPath().split('/');
    if (path.length >= 4 + index) {
      return path[3 + index];
    }
    return null;
  };

  getCurrentPath = () => {
    return this.props.location.pathname;
  };

  onBannerMenuClick = id => {
    let newPath = "/super-admin/" + id;
    if (id === "user") {
      newPath += objToUrlParam({
        view: "all",
        wlf_id: "cleveralpha-asset-management",
      })
    }
    if (this.getCurrentPath() !== newPath) {
      this.props.navigatePath(newPath);
    }
  };

  getArgs = () => {
    return urlParamToObj(this.props.location.search);
  }

  getUserBannerButtons = () => {
    const args = urlParamToObj(this.props.location.search);

    const wlf_id = args.wlf_id;
    const view = args.view || VIEW_TYPE.username;

    const icon_style = {
      fontSize: "1.4rem",
    }
    const left_arrow = (<i style={icon_style} className="fa fa-arrow-left" aria-hidden="true"/>);
    const right_arrow = (<i style={icon_style} className="fa fa-arrow-right" aria-hidden="true"/>);

    const buttons = [
      {
        label: left_arrow,
        id: "left_arrow",
      },
      {
        label: "WLF Filter:",
        style: {
          padding: "0.2rem 0.1rem 0.2rem 1rem",
        }
      },
      {
        label: "WLF:",
        id: "wlf",
        value: wlf_id || "all",
        button_style: {
          fontSize: "0.8rem",
        },
        options: [
          {
            id: "all",
            label: "All",
          }
        ]
      },
      {
        label: right_arrow,
        id: "right_arrow",
      },
      {
        label: "View: " + view,
        id: "view",
        value: view,
        button_style: {
          fontSize: "0.8rem",
        },
        options: [
          {
            id: VIEW_TYPE.username,
            label: "Username",
          },
          {
            id: VIEW_TYPE.onboarding,
            label: "Onboarding",
          }
        ]
      }
    ];

    this.props.wlfs.forEach(wlf => {
      if (!is_uuid(wlf.id)) {
        buttons[2].options.push({
          id: wlf.id,
          label: wlf.name,
        })
      }
    });

    return buttons;
  };

  onUserBannerClick = button_id => {
    const args = urlParamToObj(this.props.location.search);

    if (button_id === "left_arrow" && "page_token" in args) {
      // We have paged forward, we can still navigate back
      window.history.back();
    } else if (button_id === "right_arrow" && this.state.page_token) {
      const args = urlParamToObj(this.props.location.search);
      args.page_token = this.state.page_token;
      args.timestamp = this.state.timestamp_sec;
      const path = this.props.location.pathname;
      this.props.navigatePath(path + objToUrlParam(args));
    }
  };

  onPopupMenuClick = (menu_id, button_id) => {

    const args = urlParamToObj(this.props.location.search);
    const path = this.props.location.pathname;

    if (menu_id === "wlf") {
      if (button_id === "all" && ('wlf_id' in args || 'page_token' in args)) {
        delete args.wlf_id;
        delete args.page_token;
        this.props.navigatePath(path + objToUrlParam(args));
      } else if (button_id !== "all" && (args.wlf_id !== button_id || 'page_token' in args)) {
        args.wlf_id = button_id;
        delete args.page_token;
        this.props.navigatePath(path + objToUrlParam(args));
      }
    } else if (menu_id === "view") {
      if (args.view !== button_id) {
        args.view = button_id;
        if (args.page_token) {
          delete args.page_token;
        }
        this.props.navigatePath(path, args);
      }
    } else if (menu_id === "prod") {
      const new_path = "/super-admin/" + button_id;
      this.props.navigatePath(new_path);
    }
  };

  maybeRenderUserMenu = () => {
    if (this.getCurrentSegment() !== "user") {
      return null;
    }
    const client = this.props.client;
    const banner_color = getRGB(client.color.banner_background);
    const banner_text_color = getRGB(client.color.banner_text);
    const style = {
      paddingLeft: "7rem",
    };

    return (
      <BannerMenu
        buttons={this.getUserBannerButtons()}
        bannerColor={banner_color}
        bannerTextColor={banner_text_color}
        onClick={this.onUserBannerClick}
        onPopupMenuClick={this.onPopupMenuClick}
        style={style}
      />
    )
  };

  render() {
    const { allCSS } = this.props;
    if(!allCSS) return null;

    const args = urlParamToObj(this.props.location.search);
    const username = args.username;
    const acct_index = args.acct_index;
    const wlf_id = args.wlf_id;
    const onboarding = args.onboarding;
    const current = this.getCurrentSegment();
    const nextSegment = this.getNextSegment(0);

    const color = this.props.client.color;
    const bannerMenuProps = {
        buttons: bannerButtons,
        bannerColor: getRGB(color.banner_background),
        bannerTextColor: getRGB(color.banner_text),
        padding: 100,
        current: current,
        onClick: this.onBannerMenuClick,
    }

    let renderFunc = this.renderNothing;

    if (current === 'css-editor') {
      renderFunc = this.renderCSSEditor;
    } else if (current === 'user') {

      if (nextSegment === "dynamo") {

        renderFunc = () => (
          <DynamoDashboard
            client={this.props.client}
            token={this.props.token}
            username={username}/>);

      } else if (nextSegment === "logs") {

      } else if (nextSegment === "events") {

      } else {
        if (username) {
          renderFunc = () => (
            <UserComponent
              show_aggregate={true}
              set_menu_data={true}
              username={username}
              acct_index={acct_index}
              personal={nextSegment==="personal"}
              payments={nextSegment==="payments"}
              args={args}
              path={this.props.location.pathname}
              bannerMenuProps={bannerMenuProps}/>);
        } else if (onboarding) {
          renderFunc = () => (
            <OnboardingSummary
              username={onboarding}
              acct_index={acct_index}
              wlf_id={wlf_id} />)
          ;
        } else {
          renderFunc = () => (
            <AllSAUsers
              path={this.getCurrentPath()}
              parent={this}
              args={args}/>);
        }
      }
    } else if (current === 'wlf') {
      if (nextSegment !== null) {
        renderFunc = () => {
          return (
            <WlfComponent
              id={nextSegment}
              bannerMenu={false}
              rootPath={"/super-admin"}/>
          )
        }
      } else {
        renderFunc = () => {
            return (
                <WhiteLabelFirmsTable />
            )
        }
      }
    } else if (current === 'portfolio') {
      const acct_id = this.getNextSegment(1);
      renderFunc = () => (
        <PortfolioDashboard
          portfolio_id={acct_id}
          acct_index={args.acct_index}
          username={args.username}/>)
    } else if (current === 'wlf-admins') {
      renderFunc = () => (<SAWLFAdmins/>);
    } else if (current === "payments") {
      renderFunc = () => (<SAPayments/>);
    } else if (current === "symbols") {
      renderFunc = () => (<SASymbols/>);
    } else if (current === "allocator") {
      renderFunc = () => (<SAAllocator
        args={args}
        username={args.username}
        acct_index={args.acct_index}/>);
    } else if (current === "irr_scores") {
      renderFunc = () => (<SAIRR/>);
    } else if (current === "security_purchase") {
      renderFunc = () => (<SASecurityPurchase/>);
    } else if (current === "rebalance") {
      renderFunc = () => (
        <SANotification
          args={urlParamToObj(this.props.location.search)}
          path={this.props.location.pathname}
          title={"Rebalance"}
          queue_types={["Rebalance2"]}
          notification_types={[NotificationType.REBALANCE_REQUEST.id]}/>
      );
    } else if (current === "tests") {
      renderFunc = () => (
        <E2ETests
          args={urlParamToObj(this.props.location.search)}
          path={this.props.location.pathname}
          />);
    } else if (IS_ONBOARDING_SEGMENT(current)) {
      renderFunc = () =>
        (<div className="img-col">
            <div className="container">
              <DashboardContainer
                title={"Proxy Onboarding"}
                client={this.props.client}>
                <div style={{marginTop: "2rem"}}>Name: { args.name }</div>
                <div>Account: {args.tda_account_number}</div>
              </DashboardContainer>
              <DashboardContainer
                client={this.props.client}>
                <OnboardingUser
                  is_proxy={true}
                  username={args.username}
                  identity_id={args.identity_id}
                  account_state={args.account_state}
                  path={this.props.location.pathname}
                  args={urlParamToObj(this.props.location.search)}/>
              </DashboardContainer>
            </div>
        </div>
        );
    }

    return (
      <section className="user-page">
        <BannerMenu
          buttons={bannerButtons}
          bannerColor={getRGB(color.banner_background)}
          bannerTextColor={getRGB(color.banner_text)}
          padding={100}
          current={current}
          onPopupMenuClick={this.onPopupMenuClick}
          onClick={this.onBannerMenuClick} />

        { this.maybeRenderUserMenu() }
        { renderFunc() }

      </section>
    );
  }
}

export { Superadmin };
